import React from 'react';
import {iconName} from '@packages/systems/wfdl-Qualified';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';
const basicPlugin = Plugins.name('Basic');

const InlineCode = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    return (
      <code {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </code>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Code',
  icon: {type: 'Component', value: [basicPlugin, iconName('InlineCode')]},
  showEmpty: false,
  render: InlineCode,
  fields: {children: TListOfElement},
});

export default config;
